import type { ID, IPatientType } from "@constants";
import { generatePath } from "@routes/generatePath.ts";

const viewMedicalHistoryRoute =
  "/past-medical-history/view/:patient_id/:patient_type";
const viewPatientMedicalHistoryRoute =
  "/past-medical-history/view/:patient_type";
const pastMedicalHistoryListRoute = "/past-medical-history";

export interface IPastMedicalHistoryRoutesParams {
  patient_id: ID;
  patient_type: IPatientType;
}

export const path = {
  list: {
    route: pastMedicalHistoryListRoute,
    link: () => path.list.route,
  },
  view: {
    route: viewMedicalHistoryRoute,
    link: (params: IPastMedicalHistoryRoutesParams) =>
      generatePath(viewMedicalHistoryRoute, params),
  },
  viewPatient: {
    route: viewPatientMedicalHistoryRoute,
    link: (params: Omit<IPastMedicalHistoryRoutesParams, "patient_id">) =>
      generatePath(viewPatientMedicalHistoryRoute, params),
  },
};
